import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { handleError, handleSuccess, justCentered } from '../../helpers/utils';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { getURLFileUploadStorage } from '../../actions/files';
import { updateUserPhoto } from '../../actions/user';

export const PhotoDialog = ({
	justWatch = false,
	user = null,
	open,
	handleClose,
	refresh,
}) => {
	// State
	const [updatePhoto, setUpdatePhoto] = React.useState(false);

	// User
	const { user: c_user } = useSelector((state) => state);

	const handleGenerateFilename = () => {
		const firstName = c_user.first_name
			.toLocaleLowerCase()
			.replace(' ', '-');
		const lastName = c_user.last_name.toLocaleLowerCase().replace(' ', '-');
		return `${firstName}-${lastName}-${c_user.id}`;
	};

	// Handle upload image
	const handleUpload = async () => {
		const file = document.querySelector('#inputFileImg').files[0];
		const filename = handleGenerateFilename();
		console.log(filename);
		if (file) {
			getURLFileUploadStorage(file, filename)
				.then(async (url) => {
					await updateUserPhoto(c_user, url);
					handleClose();
					handleSuccess('Se actualizó la foto de perfil');
				})
				.catch((error) => {
					handleError(
						error,
						'Ocurrió un error al intentar subir la imagen'
					);
				});
		} else {
			handleError(null, 'Primero debes tomar una foto');
		}
	};

	return (
		<React.Fragment>
			<Dialog maxWidth='sm' open={open} onClose={handleClose}>
				<DialogTitle>Foto para registro</DialogTitle>
				<DialogContent>
					<>
						{justWatch && (
							<div style={{ ...justCentered }}>
								<img
									src={user?.img_profile}
									alt='profile_photo'
									style={{
										width: '50%',
										height: '50%',
										margin: '0 auto',
									}}
								/>
							</div>
						)}
						{(!justWatch || updatePhoto) && (
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<input
										id='inputFileImg'
										type='file'
										placeholder='Imagen a subir'
									/>
								</Grid>
							</Grid>
						)}
					</>
				</DialogContent>
				<DialogActions>
					{justWatch ? (
						<>
							<Button onClick={handleClose} color='error'>
								Salir
							</Button>
							{!updatePhoto ? (
								<Button
									onClick={() => {
										setUpdatePhoto(!updatePhoto);
									}}
								>
									Nueva foto
								</Button>
							) : (
								<Button onClick={handleUpload}>
									Subir foto
								</Button>
							)}
						</>
					) : (
						<>
							<Button onClick={handleClose} color='error'>
								Cerrar
							</Button>
							<Button onClick={handleUpload}>Subir foto</Button>
						</>
					)}
				</DialogActions>
			</Dialog>
		</React.Fragment>
	);
};
